import { render, staticRenderFns } from "./IntroductionDialog.vue?vue&type=template&id=63eb26e1"
import script from "./IntroductionDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./IntroductionDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "@/assets/scss/pages/pages.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "@/assets/scss/pages/setting.scss?vue&type=style&index=1&prod&lang=scss&external"
import style2 from "./IntroductionDialog.vue?vue&type=style&index=2&id=63eb26e1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports